import penIcon from 'assets/images/pen.svg';
import worldIcon from 'assets/images/world.svg';
import suitcaseIcon from 'assets/images/suitcase.svg';
import getAssetUrl from 'utils/getAssetUrl';

export const squareIcons: Record<string, string> = {
  education: penIcon,
  recovery: worldIcon,
  tourism: suitcaseIcon,
};

export const historyImages = [
  getAssetUrl('/assets/our-history/botanic-garden.jpg'),
  getAssetUrl('/assets/our-history/public-apperture.jpg'),
  getAssetUrl('/assets/our-history/playa-blanca.jpg'),
  getAssetUrl('/assets/our-history/giverny-2.jpg'),
  getAssetUrl('/assets/our-history/aviary.jpg'),
  getAssetUrl('/assets/our-history/giverny-humedal.jpg'),
  getAssetUrl('/assets/our-history/coorporate-events.jpg'),
  getAssetUrl('/assets/our-history/plaza-la-virgen.jpg'),
  getAssetUrl('/assets/our-history/cafeteria.jpg'),
  getAssetUrl('/assets/our-history/humedal.jpg'),
  getAssetUrl('/assets/our-history/tranque.jpg'),
];

export const teamImages = Array<string>(12).fill(
  getAssetUrl('/assets/carousel/FOTO_1.jpg')
);
